import styled from "styled-components";
import MenuButton from "../../../Shared/MenuButton";

export const MyCarvanaButton = styled(MenuButton)`
  color: ${(props) => props.theme.carvana.blue.dark};
  display: flex;
  flex: 1;
  font-size: 12px;
  justify-content: flex-start;
  padding: 15px 0;
  position: absolute;
  top: 0;
  left: 0;
  text-decoration: none;
  opacity: 1;

  ${(props) => props.animation};

  @media (min-width: ${(props) => props.theme.breakpoints.values.sm}px) {
    font-size: 14px;
    letter-spacing: 0.1px;
    min-height: 50px;
    padding: 15px 19px;
    width: 100%;
  }
`;

export const MyCarvanaSubText = styled.div`
  color: ${(props) => props.theme.carvana.gray.dark};
  font-size: 13px;
  font-weight: 400;
  text-transform: none;
`;

export const MyCarvanaWrapper = styled.div`
  position: relative;
  height: 66px;
`;
